angular.module 'zc.master.projects'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.projects',
    url: '/projects'
    views:
      'content@':
        templateUrl: '/templates/master.projects/list.html'
        controller: 'MasterProjectsListCtrl'

  .state 'admin.master.projects.new',
    url: '/new'
    views:
      'content@':
        templateUrl: '/templates/master.projects/new.html'
        controller: 'MasterProjectsNewCtrl'
        resolve:
          productLines: (Meta) ->
            Meta.getProductLines()
          project: ->
            product_line: 'zenclerk'
            pricing_type: 'volume'
          currencies: (Meta) ->
            Meta.getCurrencies()
          salesEntities: (Meta) ->
            Meta.getSalesEntities()
          pricingTypes: (Meta) ->
            Meta.getPricingTypes()
          regions: (Meta) ->
            Meta.getRegions()

  .state 'admin.master.projects.policies',
    url: '/{projectId:int}/campaign_policy_sets'
    views:
      'content@':
        templateUrl: '/templates/master.projects/master_projects_policies.html'
        controller: 'MasterProjectsPoliciesCtrl'
        resolve:
          currentProject: (Project, $stateParams) ->
            Project.get($stateParams.projectId)
          campaignPolicySets: (MasterCampaignPolicySet, $stateParams) ->
            MasterCampaignPolicySet.all($stateParams.projectId)

  .state 'admin.master.projects.policies.show',
    url: '/{campaignPolicySetId:int}'
    views:
      'content@':
        templateUrl: '/templates/master.projects/master_projects_policies.html'
        controller: 'MasterProjectsPoliciesCtrl'
        resolve:
          currentProject: (Project, $stateParams) ->
            Project.get($stateParams.projectId)
          campaignPolicySets: (MasterCampaignPolicySet, $stateParams) ->
            MasterCampaignPolicySet.all($stateParams.projectId)

  .state 'admin.master.projects.campaigns',
    url: '/{projectId:int}/campaigns'
    abstract: true

  .state 'admin.master.projects.campaigns.segment',
    url: '/{campaignId:int}/segment'
    views:
      'mainnav@':
        templateUrl: '/templates/core/views/mainnav.html'
        controller: 'MainnavCtrl'
        resolve:
          currentProject: (Project, $stateParams) ->
            Project.get($stateParams.projectId)
      'content@':
        templateUrl: '/templates/master.projects/master_campaign_segment_detail.html'
        controller: 'MasterCampaignSegmentDetailCtrl'
        resolve:
          currentProject: (Project, $stateParams) ->
            Project.get($stateParams.projectId)
          currentCampaign: (MasterCampaign, $stateParams) ->
            MasterCampaign.get({projectId: $stateParams.projectId, campaignId: $stateParams.campaignId})



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.projects/routes.js.coffee